<template>
    <kgr-button
        :value="label"
        type="grey"
        :pending="pending"
        :disabled="disabled"
        :title="title"
        @click="archive()"
    />
</template>

<script>
import KgrButton from '../common/form/button/KgrButton.vue';
import Offering from '../../js/dto/offering/Offering';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository';

export default {
    components: {
        'kgr-button': KgrButton,
    },
    props: {
        offering: {
            type: Offering,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
        };
    },
    computed: {
        label() {
            if (this.offering.archived) {
                return this.$t('offering.restoreOffering');
            }
            return this.$t('Archivieren');
        },
        title() {
            if (this.disabled) {
                return this.$t('offering.archiveOffering.disabled');
            }
            return '';
        },
        disabled() {
            return !this.offering.isArchivable;
        },
    },
    methods: {
        archive() {
            const message = this.offering.archived ? this.$t('offering.restore.confirm') : this.$t('offering.archive.confirm');
            showConfirm(this.$t('confirmInformal'), message, () => {
                this.offering.archived ? this.restoreOffering() : this.archiveOffering();
            }, 'Ok');
        },
        archiveOffering() {
            this.pending = true;
            OfferingRepository.archive(this.offering.id)
                .then(() => {
                    this.$notify.success('offering.archive.success');
                    this.$emit('archiveOffering');
                })
                .catch(() => this.$notify.error('offering.archive.error'))
                .finally(() => this.pending = false);
        },
        restoreOffering() {
            this.pending = true;
            OfferingRepository.archive(this.offering.id)
                .then(() => {
                    this.$notify.success('offering.restore.success');
                    this.$emit('restoreOffering');
                })
                .catch(() => this.$notify.success('offering.restore.error'))
                .finally(() => this.pending = false);
        },
    },
};
</script>

<style scoped lang="scss"></style>
